import { FC } from "react"
import styled from "styled-components"
import Color from "../../constants/Color"
import coffee from "../../images/coffee.jpg"
import * as Animation from "../../functionality/Animation"

interface Props {
    widthInPx: number
    left: string
    bottom: string
    saturation: number
}

// The dimensions of the source image
const imageWidth = 1510
const imageHeight = 1007
const imageLeftOffset = 180     // The position of the left edge of the coffee in the image
const imageBottomOffset = 380   // The position of the bottom edge of the coffee in the image
const imageTopOffset = 140      // The position of the top edge of the coffee in the image

// const imageRightOffset: Animation.VariableValue = {
//     end: 0,
//     start: 0,
//     endControl: 800,    // Width in px
//     startControl: 400,    // Width in px
// }

const Coffee: FC<Props> = ({ widthInPx, left, bottom, saturation }) => {

    // const imageRightOffsetInPx = Animation.calculateValue(imageRightOffset, widthInPx)
    const imageScale = (widthInPx / (imageWidth - imageLeftOffset))
    const heightInPx = ((imageHeight - imageBottomOffset - imageTopOffset) * imageScale)
    const imageLeftOffsetInPx = (imageLeftOffset * imageScale)
    const imageBottomOffsetInPx = (imageBottomOffset * imageScale)

    return <Wrapper left={left} bottom={bottom} widthInPx={widthInPx} heightInPx={heightInPx}>
        <Image src={coffee} saturation={saturation}
                            leftInPx={-imageLeftOffsetInPx}
                            bottomInPx={-imageBottomOffsetInPx}
                            widthInPx={widthInPx + imageLeftOffsetInPx}/>
        <Overlay widthInPx={widthInPx} heightInPx={heightInPx * 0.8}/>
    </Wrapper>
}

export default Coffee

const Wrapper = styled.div.attrs<{widthInPx: number, heightInPx: number, left: string, bottom: string}>(p => ({
    style: {
        left: p.left,
        bottom: p.bottom,
        width: p.widthInPx + "px",
        height: p.heightInPx + "px",
    }
}))`
    position: absolute;
    overflow: hidden;
    background-color: ${Color.Black};
`

const Image = styled.img.attrs<{leftInPx: number, bottomInPx: number, widthInPx: number, saturation: number, }>(p => ({
    style: {
        filter: `saturate(${p.saturation * 100}%)`,
        left: p.leftInPx + "px",
        bottom: p.bottomInPx + "px",
        width: p.widthInPx + "px",
    }
}))`
    position: absolute;
    bottom: 0;
`

const Overlay = styled.div.attrs<{widthInPx: number, heightInPx: number}>(p => ({
    style: {
        width: p.widthInPx + "px",
        height: p.heightInPx + "px",
    }
}))`
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(to bottom, ${Color.Black} 0%, ${Color.Black + "00"} 100%);
`